import PageMeta from './PageMeta';
import {
  RedesignFooter,
  RedesignHeader,
  RedesignPage,
  SiteLink,
} from './RedesignShell';

const workBenefits = [
  'работу с реальными проектами',
  'опыт в комплексных digital решениях',
  'участие в разработке и продвижении проектов',
  'команду профессионалов',
];

const duties = [
  'ведение проектов и взаимодействие с клиентами',
  'постановка задач команде (разработка, дизайн, SEO)',
  'контроль сроков выполнения задач',
  'участие в развитии проектов клиентов',
  'работа с CRM системой',
  'подготовка отчетности',
];

const requirements = [
  'опыт работы аккаунт-менеджером или менеджером проектов от 1 года',
  'понимание digital услуг (разработка сайтов, приложений, SEO, реклама)',
  'навыки коммуникации с клиентами',
  'ответственность и системное мышление',
  'умение работать с задачами и сроками',
];

const conditions = [
  'работа в digital агентстве полного цикла',
  'офис / удаленный формат',
  'график 5/2',
  'конкурентная заработная плата',
  'работа с интересными проектами',
  'возможность карьерного роста',
];

const advantages = [
  'команда профессионалов digital студии',
  'участие в крупных проектах',
  'опыт работы с бизнесом',
  'развитие в IT и digital сфере',
  'прозрачные процессы',
];

const vacancyBlocks = [
  ['Обязанности', duties],
  ['Требования', requirements],
  ['Условия работы', conditions],
  ['Преимущества работы с нами', advantages],
];

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function SectionHeader({ title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function VacanciesRedesignPage() {
  return (
    <RedesignPage>
      <PageMeta
        title="Вакансии digital агентства — работа в IT компании Москва"
        description="Вакансии digital агентства: работа в IT компании, открытые позиции, карьерные возможности."
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <h1>Вакансии digital агентства Fatality</h1>
            <p className="hero-sub">Мы — digital агентство полного цикла, которое занимается разработкой сайтов, приложений и продвижением проектов.</p>
            <p className="service-hero-copy">Наша команда — это профессионалы digital индустрии, которые работают над сложными и интересными задачами для бизнеса.</p>
            <p className="service-hero-copy">Если вы хотите развиваться в IT и digital — присоединяйтесь к нашей команде.</p>
          </div>
          <div className="service-hero-panel" aria-label="Вакансии digital агентства Fatality">
            {workBenefits.map((item, index) => (
              <div className="panel-line" key={item}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{item}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Работа в digital агентстве"
            description="Мы предлагаем работу в IT компании в Москве с возможностью профессионального роста и развития."
          />
          <div className="split-proof">
            <div>
              <p>В нашей digital студии вы получите:</p>
              <BulletList items={workBenefits} />
            </div>
            <div>
              <p>Мы ищем специалистов, которые хотят развиваться и работать на результат.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Открытые вакансии" description="В данный момент в нашем digital агентстве открыта следующая позиция:" />
          <div className="compact-card-grid">
            <div className="compact-card">
              <div className="compact-num">01</div>
              <h3>Аккаунт-менеджер в IT-агентство</h3>
              <p>Аккаунт-менеджер — ключевая роль в работе с клиентами и управлении проектами.</p>
              <p>Специалист отвечает за коммуникацию с клиентами, контроль задач и развитие проектов.</p>
            </div>
          </div>
          <div className="compact-card-grid section-action">
            {vacancyBlocks.map(([title, items], index) => (
              <div className="compact-card" key={title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{title}</h3>
                <BulletList items={items} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark title="Как откликнуться на вакансию" description="Чтобы откликнуться на вакансию, отправьте резюме:" />
          <div className="compact-card-grid">
            <div className="compact-card">
              <p>Email: <SiteLink href="mailto:fatality.develop@gmail.com" className="link-flat">fatality.develop@gmail.com</SiteLink></p>
              <p>Менеджер свяжется с вами и расскажет о дальнейших этапах.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader title="Почему стоит работать у нас" />
          <div className="split-proof">
            <p>Мы — надежное digital агентство, которое ценит сотрудников и создает комфортные условия для работы.</p>
            <p>Мы помогаем развиваться, участвовать в интересных проектах и расти вместе с компанией.</p>
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default VacanciesRedesignPage;
